/**
 * @module mainmenu
 */
/** comment to work-around limitation of typedoc module plugin */

// Copyright 2018-2024 Enlightware GmbH, Switzerland

import './about-content.scss';


import { nonnull } from 'utils/types';
import { UserVersion } from 'apps/common/version';

// eslint-disable-next-line no-underscore-dangle
declare const __CODE_VERSION__: string;
// eslint-disable-next-line no-underscore-dangle
declare const __RUST_VERSION__: string;
// eslint-disable-next-line no-underscore-dangle
declare const __BUILD_FLAGS__: string;

const buildFlags = __BUILD_FLAGS__.length !== 0 ? `, ${__BUILD_FLAGS__}` : '';

nonnull(document.getElementById('version-user')).innerText = `Version ${UserVersion}`;
nonnull(document.getElementById('version-build')).innerText = `build ${__CODE_VERSION__} (${__RUST_VERSION__}${buildFlags})`;

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('logged') !== null) {
	nonnull(document.getElementById('feedback-logged')).style.display = '';
} else {
	nonnull(document.getElementById('feedback-unLogged')).style.display = '';
}